// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.qcj3l2___currentCountry {\n  \n}\n", "",{"version":3,"sources":["webpack://./packages/moyopros/public/src/styles/components/CountrySelector.module.css"],"names":[],"mappings":";AACA;;AAEA","sourcesContent":["\n.currentCountry {\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currentCountry": "qcj3l2___currentCountry"
};
export default ___CSS_LOADER_EXPORT___;
